/* eslint-disable */
// src/components/VisitTransactionDetails/addVisitTransactionButton.js

import React from "react";
import { Alert, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { navigateAddVisitTransactionHelper } from "utils/navigateAddVisitTransactionHelper";
import VisitTransactionService, {
  getStartOrResumeCollectionDraftErrorInfo,
} from "services/visitTransactionService";
import { successContainedButtonSx } from "components/common/buttonStyles";

export default function AddVisitTransactionButton({
  local,
  profitPercentages,
  localMachineDetails,
  disabled = false,
  returnTo = null,
}) {
  const navigate = useNavigate();
  const [todayState, setTodayState] = React.useState({
    state: "none",
    visitId: null,
    visitWithCollectionId: null,
    status: null,
    visitDateTime: null,
    collectionKind: null,
  });
  const [loadingStatus, setLoadingStatus] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [startError, setStartError] = React.useState("");

  React.useEffect(() => {
    if (!local?.Id) return undefined;

    let alive = true;
    setLoadingStatus(true);

    (async () => {
      try {
        const result = await VisitTransactionService.getTodayCollectionStatusByLocal(local.Id);
        if (!alive) return;
        setTodayState(
          result || {
            state: "none",
            visitId: null,
            visitWithCollectionId: null,
            status: null,
            visitDateTime: null,
            collectionKind: null,
          }
        );
      } catch {
        if (!alive) return;
        setTodayState({
          state: "none",
          visitId: null,
          visitWithCollectionId: null,
          status: null,
          visitDateTime: null,
          collectionKind: null,
        });
      } finally {
        if (alive) setLoadingStatus(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [local?.Id]);

  const buttonLabel = (() => {
    if (submitting) return "Abriendo recaudación...";
    if (loadingStatus) return "Consultando recaudación...";
    if (todayState?.state === "in_process") return "Continuar recaudación en proceso";
    if (todayState?.state === "complete") return "Ya existe recaudación de hoy";
    return "Agregar Recaudación";
  })();

  const isButtonDisabled =
    disabled || submitting || loadingStatus || todayState?.state === "complete";

  return (
    <Box sx={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start", gap: 1 }}>
      <Button
        variant="contained"
        color="success"
        disabled={isButtonDisabled}
        sx={successContainedButtonSx}
        onClick={async () => {
          if (!local?.Id || isButtonDisabled) return;

          setStartError("");
          setSubmitting(true);
          try {
            const result = await navigateAddVisitTransactionHelper(
              navigate,
              local,
              profitPercentages,
              localMachineDetails,
              VisitTransactionService,
              returnTo ? { state: { returnTo } } : {}
            );
            setTodayState((prev) => ({
              ...prev,
              ...(result || {}),
              state: "in_process",
            }));
          } catch (error) {
            const errorInfo = getStartOrResumeCollectionDraftErrorInfo(error);
            if (
              errorInfo.code === "COLLECTION_DAILY_ALREADY_COMPLETE" ||
              errorInfo.code === "COLLECTION_DAILY_IN_PROCESS_EXISTS"
            ) {
              try {
                const refreshed = await VisitTransactionService.getTodayCollectionStatusByLocal(
                  local.Id
                );
                setTodayState(refreshed || todayState);
              } catch {}
            }
            setStartError(
              errorInfo.message || "No se pudo iniciar la recaudación. Intenta nuevamente."
            );
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {buttonLabel}
      </Button>
      {startError && (
        <Alert severity="error" onClose={() => setStartError("")}>
          {startError}
        </Alert>
      )}
    </Box>
  );
}
